import React from 'react'

const PARTNERS = [
  { name: 'Huawei', logo: 'Huawei.png' },
  { name: 'MTN', logo: 'mtn.jpg' },
  { name: 'RwandAir', logo: 'RwandAir-Logo.wine.png' },
  { name: 'Qatar Airways', logo: 'Qatar.png' },
  { name: 'KICS', logo: 'KICS.png' },
  { name: 'Inkomoko', logo: 'inkomoko.png' },
  { name: 'BSC', logo: 'BSC.png' },
  { name: 'RBA', logo: 'rba.png' },
  { name: 'NCBA', logo: 'ncba.png' },
  { name: 'Tele10', logo: 'tele10.png' },
  { name: 'Frontier', logo: 'frontier.png' },
  { name: 'RITCO', logo: 'ritco.png' },
]

/** "Trusted partners" strip: section heading and a looping, monochrome logo marquee. */
function TrustedPartners() {
  // The list is rendered twice so the marquee can loop seamlessly; the copy is hidden from screen readers.
  const renderLogos = (copy) =>
    PARTNERS.map((partner) => (
      <li key={`${copy}-${partner.name}`} className="tp__item" aria-hidden={copy ? 'true' : undefined}>
        <img src={`/assets/img/partners/${partner.logo}`} alt={copy ? '' : partner.name} loading="lazy" />
      </li>
    ))

  return (
    <section className="tp" aria-labelledby="tp-title">
      <div className="tp__container">
        <header className="tp__head">
          <span className="fab-chip">Trusted by</span>
          <h2 id="tp-title" className="fab-title">
            Our Trusted <span className="fab-gradient-text">Partners</span>
          </h2>
          <p className="fab-intro">
            Businesses, institutions and organizations across Rwanda rely on Fabritech for connectivity and security.
          </p>
        </header>
      </div>
      <div className="tp__marquee">
        <ul className="tp__track">
          {renderLogos(false)}
          {renderLogos(true)}
        </ul>
      </div>
    </section>
  )
}

export default TrustedPartners
